export default __webpack_public_path__ + "static/media/ET_2022-23.1a3d7f90.webm";